var _a;
export var EAccountType;
(function (EAccountType) {
    EAccountType[EAccountType["OverAll"] = 1] = "OverAll";
    EAccountType[EAccountType["MulOrgan"] = 3] = "MulOrgan";
    EAccountType[EAccountType["MulDepto"] = 2] = "MulDepto";
})(EAccountType || (EAccountType = {}));
export default EAccountType;
export var AccountTypeDict = (_a = {},
    _a[EAccountType.OverAll] = "整体对账",
    _a[EAccountType.MulOrgan] = "多机构对账",
    _a[EAccountType.MulDepto] = "多仓库对账",
    _a);
